import React from 'react'

const JS_Essentials_Assignment_4 = () => {
  return (
    <div>
      <h1>JS EssentialsAssignment 4</h1>
    </div>
  )
}

export default JS_Essentials_Assignment_4
